import { RegisterOptions } from "react-hook-form";

import { SelectOptionTypes } from "../../../../components/Input";
import { TransactionTypeOptions } from "../../../Transactions";
import { toIsoDate } from "../../../../utils/dates";
import { AmountVariant } from "../../../../utils/tone";
import { ProgressObject } from "./types";

export const FORM_ID = "savings";

export const TYPE_OPTIONS = [
  { label: "Earnings", value: TransactionTypeOptions.INCOME },
  { label: "Transfer In", value: TransactionTypeOptions.TRANSFER_IN },
  { label: "Transfer Out", value: TransactionTypeOptions.TRANSFER_OUT },
] as SelectOptionTypes[];

// Compact labels for the type segmented control (three across one row).
export const SEGMENT_LABELS: Record<string, string> = {
  [TransactionTypeOptions.INCOME]: "Earnings",
  [TransactionTypeOptions.TRANSFER_IN]: "In",
  [TransactionTypeOptions.TRANSFER_OUT]: "Out",
};

export const TONE_BY_TYPE: Record<string, AmountVariant> = {
  [TransactionTypeOptions.INCOME]: "income",
  [TransactionTypeOptions.TRANSFER_IN]: "income",
  [TransactionTypeOptions.TRANSFER_OUT]: "expense",
};

export const AMOUNT_RULES: RegisterOptions<ProgressObject> = {
  required: "Amount is required",
  min: { value: 0.01, message: "Amount must be greater than 0" },
  deps: ["taxWithheld"],
};

export const createDefaultProgress = () => ({
  amount: "",
  taxWithheld: "",
  transactionType: TYPE_OPTIONS[0],
  category: null,
  subCategory: null,
  fromAccount: null,
  toAccount: null,
  transactionDate: toIsoDate(new Date()),
  note: "",
});
